// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Repoarts_PageHolder__G3-DF","tabHolder":"Repoarts_tabHolder__1dug7","onFocus":"Repoarts_onFocus__3zjhw"};